module.exports = __webpack_public_path__ + "img/AstroFrens201.fa0ab469.jpg";